import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import styles from './AdditionalServiceItem.module.scss';
import {stepperInfoActions} from "../../../store/slices/stepperInfoSlice";

const AdditionalServiceItem = ({id, name, price, icon}) => {
    const dispatch = useDispatch();
    const {services} = useSelector(state => state.stepperInfo);

    const handleSelectAdditionalService = (id, name, price) => {
        const isAlreadySelected = !!services.some(item => item.name === name);

        if (isAlreadySelected) {
            dispatch(stepperInfoActions.removeService({id}));
        } else {
            dispatch(stepperInfoActions.addService({id, name, price}));
        }
    }

    return (
        <div
            onClick={() => handleSelectAdditionalService(id, name, +price)}
            className={`${styles.serviceItem} ${!!services?.some(item => item.name === name) ? styles.selected : ''}`}
        >
            <div className={styles.serviceItem_photo} dangerouslySetInnerHTML={{__html: icon}}></div>

            <div className={styles.serviceItem_description}>
                <p className={styles.serviceItem_description_title}>{name}</p>
                <p className={styles.serviceItem_description_price}>Від {+price} грн</p>
            </div>
        </div>
    );
};

export default AdditionalServiceItem;
